import React from 'react';

import SvgContainer from '../SvgContainer';

const Close = () => {
    return (
        <SvgContainer>
            <g clipPath="url(#clip0_9085_100945)">
                <path d="M15.1943 2.41714C15.6393 1.97216 15.6393 1.2507 15.1943 0.805714C14.7493 0.36073 14.0278 0.360731 13.5829 0.805714L8 6.38857L2.41714 0.805715C1.97216 0.360732 1.2507 0.36073 0.805714 0.805714C0.36073 1.2507 0.360731 1.97216 0.805714 2.41714L6.38857 8L0.805715 13.5829C0.360732 14.0278 0.36073 14.7493 0.805714 15.1943C1.2507 15.6393 1.97216 15.6393 2.41714 15.1943L8 9.61143L13.5829 15.1943C14.0278 15.6393 14.7493 15.6393 15.1943 15.1943C15.6393 14.7493 15.6393 14.0278 15.1943 13.5829L9.61143 8L15.1943 2.41714Z" />
            </g>
            <defs>
                <clipPath id="clip0_9085_100945">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </SvgContainer>
    );
};

export default Close;
